import { createTheme } from "@mui/material/styles";
const blue = '#79c9f2'
const theme = createTheme({
  direction: "rtl",



  components: {
    // CTRL + SPACE to find the component you would like to override.
    // For most of them you will need to adjust just the root...
MuiButton:{
  styleOverrides:{
    contained:{
      background:blue,
      lineHeight:'initial',
    },


    
  }
},
    MuiTextField: {
      
      styleOverrides: {
        root: {
          '& label': {
            color: blue,
          },
          '& label.Mui-focused': {
            color: blue,
          },
          '& .MuiInput-underline:after': {
            borderBottomColor: blue,
          },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: blue,
            },
            '&:hover fieldset': {
              borderColor: blue,
              borderWidth: '0.15rem',
            },
            '&.Mui-focused fieldset': {
              borderColor: blue,
            },
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          textTransform: 'initial',
          fontSize: '1rem',
        },
      },
    },
  },

  typography: {
    button: {
      textTransform: "none",
      cursor: "pointer",
    },
    fontFamily: ['Stanga',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
 

  palette: {
    outlineColor:'yellow',
    primary: {
      text: {
        primary: "#fff",
      },
      main: blue,
      contrastText: "#fff",
    },
  },
});

export default theme;
